import { useEffect, useState } from "react";
import axios from "axios";
import { SERVICEURL } from "../../appconfig";

export interface ExchangeParameter {
  id: string | number;
  name: string;
  currencyCode: string;
}

export default function useExchangeParameterList() {
  const [parameters, setParameters] = useState<ExchangeParameter[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    setIsLoading(true);
    setError(null);
    const mytoken = localStorage.getItem("token");
    axios
      .get(`${SERVICEURL}api/Data/GetExchangeParameterList`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${mytoken}`,
        },
      })
      .then((res) => {
        if (Array.isArray(res.data?.data)) {
          setParameters(res.data.data);
        } else if (Array.isArray(res.data)) {
          setParameters(res.data);
        } else {
          setParameters([]);
        }
      })
      .catch((err) => {
        setError(err.message || "Ücret birimleri yüklenemedi");
        setParameters([]);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return { parameters, isLoading, error };
}
